var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{attrs:{"width":"100%","height":"100%","frameborder":"0","scrolling":"auto","src":_vm.privacyPolicy}},[_vm._v("浏览器版本过低")])])
}
var staticRenderFns = []

export { render, staticRenderFns }